<template>
    <el-dialog 
        :visible.sync="dialogVisible" 
        width="95%"
        :before-close="handleClose"
        @open="onDialogOpen"
        top="30px"
    >
        <div slot="title" class="dialog-title">
            <div class="title-content">
                <i class="el-icon-lock" style="margin-right: 8px; color: #f56c6c;"></i>
                锁定商品
            </div>
            <div class="dialog-description">
                不需要改动的店铺商品可进行商品锁定则不会修改,建议商家把畅销品锁定,避免修改期间出单影响时效。
            </div>
        </div>
        <div class="lock-product-dialog">

            <!-- 筛选条件 -->
            <div class="filter-conditions">
                <!-- 第一行 -->
                <div class="query-row">
                    <div class="query-item">
                        <div class="query-item-title">地区：</div>
                        <div class="query-item-content">
                            <label class="custom-radio" @click="onRegionChange('all')">
                                <input type="radio" name="region" value="all" v-model="query.region">
                                <span class="custom-radio-btn">全部</span>
                            </label>
                            <label class="custom-radio" @click="onRegionChange('tw')">
                                <input type="radio" name="region" value="tw" v-model="query.region">
                                <span class="custom-radio-btn">台湾</span>
                            </label>
                        </div>
                    </div>
                    <div class="query-item">
                        <div class="query-item-title">店铺：</div>
                        <div class="query-item-content">
                            <el-input type="text" style="width: 150px;" @input="getShops" name="shopName" size="small" placeholder="请输入关键词" v-model="shopKeyword" />
                            <label class="custom-radio" @click.prevent="onShopSelect(0)">
                                <input type="radio" name="shopId" value="0" v-model="query.shopId">
                                <span class="custom-radio-btn">全部</span>
                            </label>
                            <label class="custom-radio"
                                   v-for="shop in (showAllShops ? shops : shops.slice(0, 10))"
                                   :key="shop.id"
                                   @click.prevent="onShopSelect(shop.id)"
                                   >
                                <input type="radio" name="shopId" :value="shop.id" v-model="query.shopId">
                                <span class="custom-radio-btn">{{shop.actualName?shop.actualName:shop.name}}</span>
                            </label>
                            <button
                              v-if="!showAllShops && shops.length > 10"
                              class="more-btn"
                              @click="showAllShops = true"
                            >
                              更多(+{{ shops.length - 10 }})
                            </button>
                            <button
                              v-if="showAllShops && shops.length > 10"
                              class="more-btn"
                              @click="showAllShops = false"
                            >
                              收起
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 第二行 -->
                <div class="query-section">
                    <!-- 查询条件 -->
                    <div class="query-conditions">
                        <!-- 原第二行 -->
                        <div class="query-row-no-gap">
                            <div class="query-item query-item-1">
                                <div class="query-item-title">商品筛选：</div>
                                <div class="query-item-content">
                                    <el-select
                                      class="row2-col1-select"
                                      v-model="currentSearchType"
                                      size="small"
                                      placeholder="请选择"
                                      @change="onSearchTypeChange"
                                    >
                                      <el-option
                                        v-for="item in searchTypes"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                      ></el-option>
                                    </el-select>
                                    <el-input
                                      class="row2-col1-input"
                                      type="text"
                                      :name="currentSearchType"
                                      size="small"
                                      clearable
                                      :placeholder="currentPlaceholder"
                                      v-model="query[currentSearchType]"
                                    />
                                </div>
                            </div>
                            <div class="query-item query-item-2">
                                <div class="query-item-title">发货时效：</div>
                                <div class="query-item-content">
                                    <el-select class="row2-col2-select" v-model="query.isPreOrder" size="small" placeholder="请选择">
                                        <el-option label="全部" :value="0"></el-option>
                                        <el-option label="现货" :value="1"></el-option>
                                        <el-option label="预售" :value="2"></el-option>
                                    </el-select>
                                    <el-checkbox class="row2-col2-checkbox" v-model="query.nextDayDelivery" size="small">隔日到货</el-checkbox>
                                </div>
                            </div>
                            <div class="query-item query-item-3">
                                <div class="query-item-title">创建时间：</div>
                                <div class="query-item-content">
                                    <el-date-picker class="row2-col3-date" size="small" 
                                        v-model="query.Date" clearable
                                        value-format="yyyy-MM-dd"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- 原第三行 -->
                        <div class="query-row-no-gap">
                            <div class="query-item query-item-1">
                                <div class="query-item-title">数据筛选：</div>
                                <div class="query-item-content">
                                    <el-select class="row3-col1-select" v-model="query.dataType" size="small" @change="onDataTypeChange" placeholder="请选择">
                                        <el-option label="销量" value="sale"></el-option>
                                        <el-option label="浏览量" value="views"></el-option>
                                        <el-option label="收藏量" value="likes"></el-option>
                                        <el-option label="评论数" value="commentCount"></el-option>
                                        <el-option label="星级" value="ratingStar"></el-option>
                                    </el-select>
                                    <el-input type="number" class="row3-col1-input1" size="small" placeholder="最低值" v-model="query.minValue" />
                                    -
                                    <el-input type="number" class="row3-col1-input2" size="small" placeholder="最高值" v-model="query.maxValue" />
                                </div>
                            </div>
                            <div class="query-item query-item-2">
                                <div class="query-item-title">是否锁定：</div>
                                <div class="query-item-content">
                                    <el-select class="row3-col2-select" v-model="query.isLocked" size="small" placeholder="请选择">
                                        <el-option label="全部" :value="0"></el-option>
                                        <el-option label="已锁定" :value="1"></el-option>
                                        <el-option label="未锁定" :value="2"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="query-item query-item-3">
                                <div class="query-item-title">商品状态：</div>
                                <div class="query-item-content">
                                    <el-select class="row3-col3-select" v-model="query.itemStatus" size="small" placeholder="请选择">
                                        <el-option label="在售中" value="NORMAL"></el-option>
                                        <el-option label="已售罄" value="SOLDOUT"></el-option>
                                        <el-option label="审查中" value="REVIEWING"></el-option>
                                        <el-option label="未上架" value="UNLIST"></el-option>
                                        <el-option label="被禁售" value="BANNED"></el-option>
                                        <el-option label="已删除" value="DELETED"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 查询按钮 -->
                    <div class="query-button">
                        <el-button type="primary" size="mini" icon="el-icon-search" @click="search" color="#2b92f6" radius="2px">
                            查询
                        </el-button>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div class="table-container"  id="xm-lock-product-table">
                <vxe-grid 
                    ref="dataTable" 
                    resizable border
                    export-config
                    show-overflow highlight-hover-row
                    highlight-current-row highlight-hover-column highlight-current-column
                    :data="products"
                    :columns="columns"
                    @cell-click="checkRow"
                ></vxe-grid>
            </div>

        </div>
        
        <div slot="footer" class="dialog-footer-actions">
            <div class="footer-left">
                <div>
                    <label class="custom-radio" @click.prevent="selectAll">
                        <input type="radio" name="selectAction" value="all" :checked="selectAction === 'all'">
                        <span class="custom-radio-btn">全选</span>
                    </label>
                    <label class="custom-radio" @click.prevent="invertSelection">
                        <input type="radio" name="selectAction" value="invert" :checked="selectAction === 'invert'">
                        <span class="custom-radio-btn">反选</span>
                    </label>
                </div>
                <span class="data-count">共{{ totalCount }}条数据</span>
                <el-button type="primary" size="small" icon="el-icon-lock" @click="bulkLock">批量锁定</el-button>
                <el-button type="danger" size="small" icon="el-icon-unlock" @click="bulkUnlock">批量解锁</el-button>
            </div>
            <div class="footer-right">
                <el-select v-model="pageSize" size="small" style="width: 100px;">
                    <el-option label="20条/页" :value="20"></el-option>
                    <el-option label="50条/页" :value="50"></el-option>
                    <el-option label="100条/页" :value="100"></el-option>
                </el-select>
                <el-pagination
                    :current-page="currentPage"
                    :page-size="pageSize"
                    :total="totalCount"
                    layout="prev, pager, next"
                    @current-change="handlePageChange"
                />
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'LockProductDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            currentPage: 1,
            pageSize: 20,
            totalCount: 0,
            selectAction: null,
            query: {
                region: 'all',
                shopId: 0,
                itemName: '',
                itemId: '',
                itemSku: '',
                isPreOrder: 0,
                nextDayDelivery: false,
                Date: [],
                dataType: 'sale',
                minValue: null,
                maxValue: null,
                isLocked: 0,
                itemStatus: 'NORMAL'
            },
            shops: [],
            showAllShops: false,
            shopKeyword: '',
            currentSearchType: 'itemName',
            currentPlaceholder: '请输入商品标题',
            searchTypes: [
                {
                    label: '商品标题',
                    value: 'itemName',
                    placeholder: '请输入商品标题'
                },
                {
                    label: '商品ID',
                    value: 'itemId',
                    placeholder: '请输入商品ID'
                },
                {
                    label: 'SKU',
                    value: 'itemSku',
                    placeholder: '请输入SKU'
                }
            ],
            products: [],
            columns: [
                {type: 'checkbox', minWidth: 50, width: 50, fixed: 'left'},
                {
                    field: 'productInfo', title: '商品信息', width: 350, className: 'product-info-column',
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="product-info">
                                    <img src={row.mainImage} class="product-image" />
                                    <div class="product-details">
                                        <div class="product-title">{row.itemName}</div>
                                        <div class="product-id">商品ID：
                                            <span class="product-id-text">{row.itemId}</span>
                                            <i class="product-id-copy el-icon-document-copy"></i>
                                        </div>
                                        <div class="product-sku">主货号：{row.itemSku || '--'}</div>
                                    </div>
                                </div>
                            ];
                        },
                    }
                },
                {
                    field: 'price', title: '价格', className: 'price-info-column',
                    slots: {
                        default: ({ row }) => {
                            const minPrice = row.minSkuPrice;
                            const maxPrice = row.maxSkuPrice;
                            const priceStr = minPrice === maxPrice ? `${minPrice}` : `${minPrice} ~ ${maxPrice}`;
                            const cnyPrice = Math.round(minPrice * 0.23);
                            const cnyPriceStr = minPrice === maxPrice ? `${cnyPrice}` : `${Math.round(minPrice * 0.23)} ~ ${Math.round(maxPrice * 0.23)}`;
                            
                            return [
                                <div class="price-info">
                                    <div class="price-twd">TWD {priceStr}</div>
                                    <div class="price-cny">CNY {cnyPriceStr}</div>
                                </div>
                            ];
                        },
                    }
                },
                {
                    field: 'inventory', title: '库存/重量', 
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="inventory-info">
                                    <div>库存：{row.stock}</div>
                                    <div>重量：{row.weight}</div>
                                </div>
                            ];
                        },
                    }
                },
                {
                    field: 'data', title: '数据', className: 'data-info-column',
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="data-info">
                                    <div>销量：<span class="data-info-text">{row.sale}</span></div>
                                    <div>浏览量：<span class="data-info-text">{row.views}</span></div>
                                    <div>收藏量：<span class="data-info-text">{row.likes}</span></div>
                                    <div>评论数：<span class="data-info-text">{row.commentCount}</span></div>
                                    <div>星级：<span class="data-info-text">{row.ratingStar}</span></div>
                                </div>
                            ];
                        },
                    }
                },
                {
                    field: 'store', title: '店铺/时间', width: 350, className: 'store-info-column',
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="store-info">
                                    <div class="store-name">{row.shopName}</div>
                                    <div class="time-info">
                                        <div>创建时间：{row.createTime}</div>
                                        <div>更新时间：{row.updateTime}</div>
                                    </div>
                                </div>
                            ];
                        },
                    }
                },
                {
                    field: 'operation', title: '操作', width: 80,
                    slots: {
                        default: ({ row }) => {
                            return [
                                <div class="operation-cell">
                                    <el-switch
                                        v-model={row.isLocked}
                                        active-color="#13ce66"
                                        inactive-color="rgb(221, 221, 221)"
                                        onChange={(value) => this.handleToggleLock(row, value)}
                                    />
                                </div>
                            ];
                        },
                    }
                }
            ]
        }
    },
    computed: {
        docHeight() {  //表格的高度
            var height = this.$store.state.docHeight;
            return height - 600;
        },
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        onDialogOpen() {
            this.getShops();
            this.getProducts();
        },
        handleClose() {
            this.dialogVisible = false;
            this.resetForm();
        },
        resetForm() {
            this.query = {
                region: 'all',
                shopId: 0,
                productTitle: '',
                deliveryTime: 'all',
                nextDayDelivery: false,
                createTime: [],
                dataType: 'sales',
                minValue: '',
                maxValue: '',
                isLocked: 'all',
                productStatus: 'onsale'
            };
            this.currentPage = 1;
        },
        onRegionChange(value) {
            this.query.region = value;
        },
        onShopSelect(id) {
            this.query.shopId = id;
            this.getProducts(true);
        },
        onSearchTypeChange(val) {
            const type = this.searchTypes.find(item => item.value === val);
            this.currentPlaceholder = type ? type.placeholder : '';
            // 清空其他搜索字段
            this.query.itemName = '';
            this.query.itemId = '';
            this.query.itemSku = '';
        },
        onDataTypeChange(value) {
            this.query.dataType = value;
            this.query.minValue = null;
            this.query.maxValue = null;
        },
        getShops(queryString) {
            let param = {
                start: 0,
                type:0,
                name: queryString || this.shopKeyword,
            }
            
            this.$axios.post(
                this.$kit.api.shop.list, 
                param
            ).then((result) => {
                if(result.status){
                    this.shops = result.data.list.map(d => {
                        return {
                            id: d.shopId,
                            name: d.name,
                            actualName: d.actualName,
                        }
                    });
                }
            }).catch(error => {
                console.error('获取店铺列表失败:', error);
            });
        },
        getProducts(refresh) {
            // 引入JSON文件中的mock数据
            // import('./lockProductMockData.json').then(data => {
            //     this.products = data.default.records || data.records;
            //     this.totalCount = parseInt(data.default.total || data.total);
            // }).catch(error => {
            //     console.error('Failed to load mock data:', error);
            //     this.products = [];
            // });
            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
            }else{
                this.query.pageIndex = this.currentPage;
                this.query.start = (this.currentPage - 1) * this.pageSize;
            }

            if(this.query.nextDayDelivery){
                this.query.isPreOrder = 1;
            }else{
                this.query.isPreOrder = 0;
            }

            var param = this.$kit.rebuildQuery(this.query);
            
            this.$axios.post(this.$kit.api.shopProduct.itemList, param)
                .then((result) => {
                    if(result.status){
                        this.products = result.data.list;
                        this.totalCount = result.data.total;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        search() {
            console.log('搜索条件:', this.query);
            this.getProducts();
        },
        checkRow({row, $event}){
            if($event.target.className.indexOf("vxe-checkbox--icon")== -1){
                var table = this.$refs.dataTable;
                table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))
                this.selectAction = null;
            }
            // 手动选择时重置selectAction状态
        },
        selectAll() {
            this.selectAction = 'all';
            var table = this.$refs.dataTable;
            table.setAllCheckboxRow(true);
        },
        invertSelection() {
            this.selectAction = 'invert';
            var table = this.$refs.dataTable;
            const checkedRows = table.getCheckboxRecords();
            table.clearCheckboxRow();
            const allRows = this.products;
            const uncheckedRows = allRows.filter(row => !checkedRows.includes(row));
            table.setCheckboxRow(uncheckedRows, true);
        },
        bulkLock() {
            const checkedRows = this.$refs.dataTable.getCheckboxRecords();
            if (checkedRows.length === 0) {
                this.$message.warning('请选择要锁定的商品');
                return;
            }
            this.$message.success(`已锁定 ${checkedRows.length} 个商品`);
        },
        bulkUnlock() {
            const checkedRows = this.$refs.dataTable.getCheckboxRecords();
            if (checkedRows.length === 0) {
                this.$message.warning('请选择要解锁的商品');
                return;
            }
            this.$message.success(`已解锁 ${checkedRows.length} 个商品`);
        },
        handlePageChange(page) {
            this.currentPage = page;
            this.getProducts();
        },
        handleToggleLock(row, value) {
            console.log('切换锁定状态:', row, value);
            if (value) {
                this.$message.success(`商品 "${row.itemName}" 已锁定`);
            } else {
                this.$message.success(`商品 "${row.itemName}" 已解锁`);
            }
            // 这里可以调用API更新商品的锁定状态
        }
    }
}
</script>

<style scoped>
.dialog-title {
    display: flex;
    align-items: center;
    gap: 16px;
}

.title-content {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #303133;
}

.dialog-description {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
}

.lock-product-dialog {
    margin-top: -15px;
    margin-bottom: -20px;
    max-height: calc(100vh - 250px); 
    overflow-y: auto;
}

.filter-conditions {
    background: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
}

.query-section {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.query-conditions {
    flex: 1;
}

.query-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    flex-wrap: wrap;
    gap: 20px;
}

.query-row-no-gap {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    flex-wrap: nowrap;
    gap: 0;
}

.query-item {
    display: flex;
    align-items: center;
    min-width: 0;
}

.query-item-1 {
    flex: 0 0 33.33%;
    min-width: 33.33%;
}

.query-item-2 {
    flex: 0 0 33.33%;
    min-width: 33.33%;
    padding: 0px 20px;
    box-sizing: border-box;
}

.query-item-3 {
    flex: 0 0 33.33%;
    min-width: 33.33%;
}

.query-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    padding-top: 8px;
}

.query-item-title {
    width: 80px;
    min-width: 80px;
    text-align: right;
    margin-right: 10px;
    font-size: 14px;
    color: #333;
}

.query-item-content {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    min-width: 0;
    overflow: hidden;
}

.custom-radio {
    display: inline-block;
    cursor: pointer;
    user-select: none;
}

.custom-radio input[type="radio"] {
    display: none;
}

.custom-radio-btn {
    display: inline-block;
    padding: 1px 12px;
    height: 28px;
    line-height: 29px;
    background: rgba(0,0,0,0.09);
    border-radius: 2px;
    color: #333;
    border: 1px solid transparent;
    transition: all 0.2s;
    font-size: 14px;
}

.custom-radio:hover .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
}

.custom-radio input[type="radio"]:checked + .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
    border: 1px solid #0052d9;
    white-space: nowrap;
}

.more-btn {
    border-radius: 2px;
    padding: 1px 12px;
    height: 32px;
    background: rgba(0,0,0,0.09);
    color: #0052d9;
    border: none;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.2s;
    outline: none;
    margin-left: 8px;
    line-height: 26px;
}

.more-btn:hover {
    background: #f2f3ff;
}

.select-100 {
    width: 100px;
    min-width: 100px;
    max-width: 100px;
    margin-right: 8px;
}

.input-flex {
    flex: 1 1 0;
    min-width: 0;
}

.input-small {
    width: 80px;
    min-width: 80px;
    max-width: 80px;
    margin-right: 8px;
}

.input-medium {
    width: 120px;
    min-width: 120px;
    max-width: 120px;
    margin-right: 8px;
}

.table-container {
    background: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
    overflow: visible;
}

.product-info {
    display: flex;
    align-items: center;
    gap: 10px;
}

.product-image {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
}

.product-details {
    flex: 1;
}

.product-title {
    font-size: 14px;
    word-wrap: break-word;
    text-wrap: auto;
    white-space: break-spaces;
    line-height: 1.4;
    margin-bottom: 5px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.product-id, .product-sku {
    font-size: 12px;
    color: #999;
    line-height: 1.2;
}

.price-info {
    font-size: 13px;
}

.price-twd {
    font-weight: bold;
    margin-bottom: 4px;
}

.price-cny {
    color: #666;
    font-size: 12px;
}

.inventory-info, .data-info {
    font-size: 13px;
    line-height: 1.4;
}

.store-info {
    font-size: 13px;
}

.store-name {
    font-weight: bold;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    white-space: break-spaces;
    line-height: 1.4;
}

.time-info {
    font-size: 12px;
    color: #999;
}

.operation-cell {
    text-align: center;
    cursor: pointer;
}

.dialog-footer-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid #e8e8e8;
}

.footer-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.data-count {
    color: #666;
    font-size: 14px;
}

.footer-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* 第二行各列元素宽度控制 */
.row2-col1-select {
    flex: 0 0 100px;
}

.row2-col1-input {
    flex: 1;
    min-width: 0;
}

.row2-col2-select {
    flex: 7;
    min-width: 0;
}

.row2-col2-checkbox {
    flex: 3;
    min-width: 0;
}

.row2-col3-date {
    flex: 1;
    min-width: 0;
}

/* 第三行各列元素宽度控制 */
.row3-col1-select {
    flex: 2;
    min-width: 0;
}

.row3-col1-input1 {
    flex: 4;
    min-width: 0;
}

.row3-col1-input2 {
    flex: 4;
    min-width: 0;
}

.row3-col2-select {
    flex: 1;
    min-width: 0;
}

.row3-col3-select {
    flex: 1;
    min-width: 0;
}

/* 表格样式设置 */
#xm-lock-product-table /deep/ .vxe-table
, #xm-lock-product-table /deep/ .price-info-column
, #xm-lock-product-table /deep/ .data-info-column
, #xm-lock-product-table /deep/ .store-info-column {
    height: auto !important;
}

/* 表头固定样式 */
#xm-lock-product-table /deep/ .vxe-table--header-wrapper {
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
}

/* 确保表格不产生自己的滚动条 */
#xm-lock-product-table /deep/ .vxe-table--main-wrapper {
    overflow: visible !important;
}

#xm-lock-product-table /deep/ .vxe-table--body-wrapper {
    overflow: visible !important;
}

#xm-lock-product-table /deep/ .vxe-body--row .vxe-body--column:not(.col--checkbox) {
    padding: 10px 3px;
    vertical-align: top;
    height: auto;
}

#xm-lock-product-table /deep/ .vxe-body--column {
    color: black !important;
}

/* 商品信息列样式 */
#xm-lock-product-table /deep/ .product-info-column > div
, #xm-lock-product-table /deep/ .price-info-column > div
, #xm-lock-product-table /deep/ .data-info-column > div
, #xm-lock-product-table /deep/ .store-info-column > div {
    max-height: inherit !important;
}


#xm-lock-product-table /deep/ .product-id, #xm-lock-product-table /deep/ .product-sku {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 2px;
}

/* 价格列样式 */
#xm-lock-product-table /deep/ .price-info {
    height: auto;
    padding: 10px 3px;
    font-size: 13px;
}

#xm-lock-product-table /deep/ .price-info > div {
    max-height: inherit;
}

#xm-lock-product-table /deep/ .price-twd {
    font-weight: bold;
    margin-bottom: 4px;
}

#xm-lock-product-table /deep/ .price-cny {
    color: rgba(0, 0, 0, 0.6);
    font-size: 12px;
}

/* 库存/重量列样式 */
#xm-lock-product-table /deep/ .inventory-info {
    height: auto;
    padding: 10px 3px;
    font-size: 13px;
    line-height: 1.4;
}

#xm-lock-product-table /deep/ .inventory-info > div {
    max-height: inherit;
}

/* 数据列样式 */
#xm-lock-product-table /deep/ .data-info {
    height: auto;
    padding: 10px 3px;
    font-size: 13px;
    line-height: 1.4;
}

#xm-lock-product-table /deep/ .data-info > div {
    max-height: inherit;
}

/* 店铺/时间列样式 */
#xm-lock-product-table /deep/ .store-info {
    height: auto;
    padding: 10px 3px;
    font-size: 13px;
}

#xm-lock-product-table /deep/ .store-info > div {
    max-height: inherit;
}

#xm-lock-product-table /deep/ .store-name {
    font-weight: bold;
    margin-bottom: 4px;
}

#xm-lock-product-table /deep/ .time-info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
}

#xm-lock-product-table /deep/ .time-info > div {
    margin-bottom: 2px;
}

/* 操作列样式 */
#xm-lock-product-table /deep/ .operation-cell {
    height: auto;
    padding: 10px 3px;
    text-align: center;
    cursor: pointer;
}

#xm-lock-product-table /deep/ .operation-cell > div {
    max-height: inherit;
}

.product-id-text {
    color: rgba(0, 0, 0, 0.9);
}

.product-id-copy {
    color: #999;
    font-size: 12px;
    cursor: pointer;
    margin-left: 4px;
}

.data-info {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1.2;
}

.data-info-text {
    color: rgb(0, 0, 0);
}

.store-info {
    line-height: 1.2;
}

.custom-radio {
    display: inline-block;
    cursor: pointer;
    user-select: none;
}

.custom-radio input[type="radio"] {
    display: none;
}

.custom-radio-btn {
    display: inline-block;
    padding: 1px 12px;
    height: 28px;
    line-height: 26px;
    background: rgba(0,0,0,0.09);
    border-radius: 2px;
    color: #333;
    border: 1px solid transparent;
    transition: all 0.2s;
    font-size: 14px;
}

.custom-radio:hover .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
}

.custom-radio input[type="radio"]:checked + .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
    border: 1px solid #0052d9;
    white-space: nowrap;
}

</style>
